
import Vue from "vue";
import { watercraftTypeTableColumns } from "./WatercraftTypeTable";
import { ITableWrapperColumns } from "@/types";
import NoResultsFound from "@/components/NotFound/NoResultsFound.vue";
import {
  watercraftTypeMapActions,
  watercraftTypeMapGetters
} from "@/store/modules/watercraftType";

interface IWatercraftTypeData {
  tableActions: any[];
  errorMessage: string;
  isLoading: boolean;
  loading: boolean;
  successMessage: string;
  watercraftTypeId: string;
  tableRowActions: any[];
  loadingText: string;
}

export default Vue.extend({
  name: "ListWatercraftTypes",
  components: {
    NoResultsFound
  },
  data(): IWatercraftTypeData {
    return {
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      tableActions: [],
      loading: false,
      watercraftTypeId: "",
      tableRowActions: [
        { label: "Edit", value: "edit", faIcon: "edit" },
        {
          label: "Delete",
          value: "delete",
          faIcon: "trash-alt",
          class: "bg-red-400 text-white hover:text-white hover:bg-red-500"
        }
      ],
      loadingText: ""
    };
  },
  methods: {
    ...watercraftTypeMapActions(["getWatercraftTypes", "deleteWatercraftType"]),
    onToolbarItemClick(event: string) {
      switch (event) {
        case "createWatercraftType":
          this.$router.push("/admin/watercraftType/create");
          break;
      }
    },
    async fetchPageData(queryObject: any): Promise<any> {
      try {
        this.loading = true;
        this.loadingText = "Loading watercraft types. Please wait...";
        this.$emit("scrollTop");
        await this.getWatercraftTypes({ query: queryObject });
      } catch (error) {
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
      } finally {
        this.loading = false;
        this.loadingText = "";
      }
    },
    async viewCallback(dataReceived: any): Promise<any> {
      const { _id } = dataReceived;
      this.$router.push(`/admin/${_id}/watercraftType`).catch(() => {});
    },
    async handleResponseAction(payload: any) {
      const { data } = payload;
      switch (payload.name) {
        case "delete":
          this.deleteCallback(data._id);
          break;
        case "edit":
          this.$router.push(`/admin/${data._id}/watercraftType`);
          break;
        default:
          this.errorMessage = "Operation specified is not supported";
      }
    },
    async deleteOneWatercraftType(): Promise<void> {
      try {
        this.isLoading = true;
        this.loadingText = "Deleting watercraft type. Please wait...";
        await this.deleteWatercraftType(this.watercraftTypeId);
        this.$modal.hide("watercraftTypeDeleteModal");
        this.$appNotifySuccess("Watercraft Type Successfully Deleted");
      } catch (e) {
        this.errorMessage = e.message;
        this.$bugSnagClient.notify(e);
      } finally {
        this.isLoading = false;
        this.loadingText = "";
      }
    },
    deleteCallback(id: string): void {
      this.watercraftTypeId = id;
      this.$modal.show("watercraftTypeDeleteModal");
    }
  },
  computed: {
    ...watercraftTypeMapGetters([
      "watercraftTypes",
      "getTotalRecords",
      "getWatercraftTypesLinks"
    ]),
    tableColumns(): ITableWrapperColumns {
      return watercraftTypeTableColumns;
    }
  },
  mounted() {
    this.fetchPageData({});
  }
});
